import { StringSchema } from 'yup'

export default function rntrc(this: StringSchema, message: string) {
  return this.test('rntrc', message, (value = '') => {
    if (!value) return true
    const blackList = [
      '000000000',
      '111111111',
      '222222222',
      '333333333',
      '444444444',
      '555555555',
      '666666666',
      '777777777',
      '888888888',
      '999999999',
      '123456789',
      '00000000',
      '11111111',
      '22222222',
      '33333333',
      '44444444',
      '55555555',
      '66666666',
      '77777777',
      '88888888',
      '99999999',
      '12345678',
    ]

    return value.length > 7 && value.length < 10 && !blackList.includes(value)
  })
}
